const platform = {
    title: 'Configurações da plataforma',
    subtitle: 'Gerencie administradores entre locatários e a aparência global.',
    branding_title: 'Marca da plataforma',
    branding_description: 'Aplicada ao console, autenticação, central de contas, demos e central de ajuda.',
    product_name: 'Nome do produto',
    slogan: 'Slogan',
    light_logo: 'Logo do tema claro',
    dark_logo: 'Logo do tema escuro',
    upload_logo: 'Enviar logo',
    uploading: 'Enviando…',
    logo_uploaded: 'Logo enviado',
    hide_open_source_notice: 'Ocultar aviso de código aberto',
    hide_open_source_notice_description: 'Oculta links visíveis de atribuição e mantém os arquivos de licença e código-fonte.',
    save: 'Salvar alterações',
    saving: 'Salvando…',
    saved: 'Marca da plataforma salva',
    administrators_title: 'Administradores da plataforma',
    administrators_description: 'Podem gerenciar todos os locatários e configurações da instância.',
    administrator_identifier_placeholder: 'ID, nome de usuário ou e-mail',
    add_administrator: 'Adicionar administrador',
    administrator_added: 'Administrador adicionado',
    remove_administrator: 'Remover administrador',
};
export default Object.freeze(platform);
